export default "__VITE_ASSET__B9$uRgip__"